export { default as FireOutlineIcon } from './FireOutlineIcon';
